// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GuaranteeLetter-module__shadowBox--z4GGl {
    display: flex;
    margin-top: 10px;
    padding: 15px 20px;
    border-radius: 14px;
    gap: 15px;
    height: 45vh;
    background-color: white;
    overflow: hidden;
}

.GuaranteeLetter-module__errorText--ysqoq {
    margin-top: 16px;
    color: red;
    font-size: 20px;
    text-align: center;
}

.GuaranteeLetter-module__inputEmail--ggwVA {
    margin-top: 10px !important;
    width: 100%;
}

.GuaranteeLetter-module__btnSend--VkGDY {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.GuaranteeLetter-module__successText--oKCx3 {
    display: flex;
    justify-content: center;
}

.GuaranteeLetter-module__successText--oKCx3>p {
    width: 300px;
    color: green;
}

.GuaranteeLetter-module__iconAction--F7zuH:hover {
    color: #326CFD;
}`, "",{"version":3,"sources":["webpack://./src/features/insured-person-case/ui/GuaranteeLetter.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".shadowBox {\r\n    display: flex;\r\n    margin-top: 10px;\r\n    padding: 15px 20px;\r\n    border-radius: 14px;\r\n    gap: 15px;\r\n    height: 45vh;\r\n    background-color: white;\r\n    overflow: hidden;\r\n}\r\n\r\n.errorText {\r\n    margin-top: 16px;\r\n    color: red;\r\n    font-size: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.inputEmail {\r\n    margin-top: 10px !important;\r\n    width: 100%;\r\n}\r\n\r\n.btnSend {\r\n    margin-top: 20px;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.successText {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.successText>p {\r\n    width: 300px;\r\n    color: green;\r\n}\r\n\r\n.iconAction:hover {\r\n    color: #326CFD;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shadowBox": `GuaranteeLetter-module__shadowBox--z4GGl`,
	"errorText": `GuaranteeLetter-module__errorText--ysqoq`,
	"inputEmail": `GuaranteeLetter-module__inputEmail--ggwVA`,
	"btnSend": `GuaranteeLetter-module__btnSend--VkGDY`,
	"successText": `GuaranteeLetter-module__successText--oKCx3`,
	"iconAction": `GuaranteeLetter-module__iconAction--F7zuH`
};
export default ___CSS_LOADER_EXPORT___;
